import { render, staticRenderFns } from "./jinGangTu.vue?vue&type=template&id=0c99c3c5&scoped=true&"
import script from "./jinGangTu.vue?vue&type=script&lang=js&"
export * from "./jinGangTu.vue?vue&type=script&lang=js&"
import style0 from "./jinGangTu.vue?vue&type=style&index=0&id=0c99c3c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99c3c5",
  null
  
)

export default component.exports